// Chess-style clocks for timed games against people (Jack, 2026-10-23).
// Must match PRESETS in backend/clocks.py.
// "5+10" is the id kept from before; it adds 20s a Play since 2026-11-02 (Jack).
// 7 min replaced 5 min (Jack, 2026-11-02); "5" stays labelled for old games.
export const CLOCKS = [
  { id: "7", label: "7 min", sub: "each" },
  { id: "10", label: "10 min", sub: "each" },
  { id: "5+10", label: "5 min +20s", sub: "+20s per Play" },
];

export function clockLabel(id) {
  return { "7": "7 min", "5": "5 min", "10": "10 min", "5+10": "5 min + 20s" }[id] || "";
}

// "4:07" from milliseconds left.
export function formatClock(ms) {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}

// What a challenge or game's time control reads as, e.g. "5 min + 20s".
export function timeControlLabel(c) {
  if (c?.clock) return clockLabel(c.clock);
  return c?.time_control_seconds ? `${c.time_control_seconds}s per move` : "";
}
